<div class="cm-hero-section">
	<div class="cm-hero-container__overlay"></div>
	<h1>
		CropManage Web API
	</h1>
	<p>
		Integrate CropManage recommendations directly into your platform so
		growers can make smarter, faster decisions without switching tools. 
	</p>
	<button (click)="openLink('https://api.cropmanage.ucanr.edu/help')" class="cm-button--hero-cta">
		API Documentation
		<mat-icon class="material-symbols-outlined">keyboard_arrow_right</mat-icon>
	</button>
	
</div>

<div class="cm-landing-fixed-width cm-integration-scenarios-section">
	<h2>
		Integration Scenarios
	</h2>
	<p>
		Ways to integrate the CropManage Web API into your platform
	</p>
	<div class="cm-scenario-group">
		<div class="cm-scenario">
			<div class="cm-scenario__heading">
				<mat-icon class="material-symbols-outlined">
					bid_landscape
				</mat-icon>
				Analysis and Scheduling
			</div>
			<p>
				Show CropManage recommendations directly in your platform to
				forecast water needs and analyze irrigation usage.
			</p>
		</div>
		<div class="cm-scenario">
			<div class="cm-scenario__heading">
				<mat-icon class="material-symbols-outlined">
					analytics
				</mat-icon>
				Compliance
			</div>
			<p>
				Integrate CropManage with compliance and reporting systems
				to compare usage with seasonal recommendations
			</p>
		</div>
	</div>
</div>
<div class="cm-landing-fixed-width cm-what-can-you-do-section">
	<h2>
		What You Can Do
	</h2>
	<div class="cm-diagram-subsection">
		<img src="../../../../assets/images/illustrations/Web API Diagram.png" width="657" height="393"/>
		<ul>
			<li>
				Retrieve up-to-date CropManage irrigation and fertilizer
				recommendations through simple web API calls
			</li>
			<li>
				Use the API without exposing personal or operational details.
			</li>
			<li>
				Access data without creating separate accounts for each grower.
			</li>
			<li>
				Integrate with farm management systems, mobile apps, or other
				software.
			</li>
		</ul>
	</div>
</div>
<div class="cm-landing-fixed-width cm-how-to-get-started-section">
	<h2>
		How to Get Started
	</h2>
	<ol class="step-list">
		<li>
			<h3>Create a CropManage account</h3>
			<p>if you don't already have one.</p>
		</li>
		<li>
			<h3>Authenticate with the API</h3>
			<p>Use your CropManage username and password to obtain a bearer
				token.</p>
		</li>
		<li>
			<h3>Make API calls</h3>
			<p>Fetch recommendations or other available data.</p>
		</li>
	</ol>
	<p>
		The API documentation includes authentication details, and a list of
		available endpoints.
	</p>
	<div class="cm-button-pair">
		<button class="cm-view-full-list-button"
			(click)="openLink('https://api.cropmanage.ucanr.edu/help')">
			View API Documentation
			<mat-icon class="material-symbols-outlined">keyboard_arrow_right</mat-icon>
		</button>

		<button class="cm-request-crop-button"
			routerLink="/contact-us">
			Contact Us for Help
			<mat-icon class="material-symbols-outlined">keyboard_arrow_right</mat-icon>
		</button>
	</div>
</div>